import { render, staticRenderFns } from "./TributeEditorSettingsModal.vue?vue&type=template&id=2ce42c26&scoped=true"
import script from "./TributeEditorSettingsModal.vue?vue&type=script&lang=js"
export * from "./TributeEditorSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./TributeEditorSettingsModal.vue?vue&type=style&index=0&id=2ce42c26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce42c26",
  null
  
)

export default component.exports